var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5 47C36.4787 47 47 36.4787 47 23.5C47 10.5213 36.4787 0 23.5 0C10.5213 0 0 10.5213 0 23.5C0 36.4787 10.5213 47 23.5 47ZM23.5001 34.2708C29.4487 34.2708 34.2709 29.4486 34.2709 23.5C34.2709 17.5514 29.4487 12.7292 23.5001 12.7292C17.5515 12.7292 12.7293 17.5514 12.7293 23.5C12.7293 29.4486 17.5515 34.2708 23.5001 34.2708Z",
    fill: "#47B881"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3371 40.4723C32.8007 40.4723 40.4725 32.8005 40.4725 23.3368C40.4725 13.8732 32.8007 6.20142 23.3371 6.20142C13.8734 6.20142 6.20166 13.8732 6.20166 23.3368C6.20166 32.8005 13.8734 40.4723 23.3371 40.4723ZM23.5001 34.2709C29.4487 34.2709 34.2709 29.4486 34.2709 23.5C34.2709 17.5515 29.4487 12.7292 23.5001 12.7292C17.5515 12.7292 12.7293 17.5515 12.7293 23.5C12.7293 29.4486 17.5515 34.2709 23.5001 34.2709Z",
    fill: "#B0E0C9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.0c40899f.svg";
export { ForwardRef as ReactComponent };